<template>
  <header id="navigation" class="navigation">
    <div class="Stripe-header">
    <div class="container-fluid">
      <p style="display:none">Order 2 same products apply the coupon code <span>BUY2GET1</span> and get the third product added automatically for FREE.</p>
      <p style="font-size:14px;">FREE shipping in all Autoship orders</p>
    </div>
</div>
    <div class="header-top-section">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-md-2 header-contact" v-if="route.query.product != 16">
            <span
              ><a href="tel:1-888-968-3592"><i class="ri-phone-line"></i> 1-888-968-3592</a></span
            >
            <div class="header-socials">
              <ul>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61552521182584&mibextid=LQQJ4d" target="_blank" class=""
                    ><i class="ri-facebook-fill"></i
                  ></a>
                </li>
                <li>
                  <a href="https://www.instagram.com/cymcorp.international/?igsh=MWlwMTVleG84a3dkNg%3D%3D" target="_blank" class=""
                    ><i class="ri-instagram-line"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 header-info text-center">
            <template v-if="hideCLMText">
            <p style="">
              <router-link :to="{name:'Testimonials'}" style="color:#ffffff">{{ props.translationText.text.navigationHeaderText }} </router-link>
            </p>
            </template>
            <template v-else>
            <p style="">
              <router-link :to="{name:'Testimonials'}" style="color:#ffffff">Get 10% OFF for 24 hours only! </router-link>
            </p>
            </template>
          </div>
          <div class="col-md-2 header-info text-center" v-if="route.query.product != 16">
            <p style="color: rgb(255, 255, 255);">{{ props.translationText.text.shoppingLabel }}<br /><span>{{userLogin.getUserUrlInfoData.enrolling_sponsor_name}}, ID:{{ userLogin.getReferalId }} </span></p>
          </div>
          <div class="header-btns col-md-2" v-if="route.query.product != 16">
            <ul>
              <li v-if="userLogin.checkIsLoggedIn === false">
                <router-link
                  :to="{
                    name: 'JoinTeam',
                    params: { sluguser: userLogin.getUserUrlName },
                  }"
                  class="link line-animation"
                  >{{ props.translationText.text.joinTeam }}</router-link
                >
              </li>
              <li>                
                <router-link
                  v-if="userLogin.getUserUrlName != null"
                  class="link line-animation"
                  :to="{
                    name: 'Product',
                    params: { sluguser: userLogin.getUserUrlName },
                  }"
                  >{{ props.translationText.text.shopHere }}</router-link
                >
                <router-link
                  v-else
                  class="link line-animation"
                  :to="{
                    name: 'Product',
                  }"
                  >{{ props.translationText.text.shopHere }}</router-link
                >
              </li>
              <li v-if="userLogin.checkIsLoggedIn === true">
                <button
                  class="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton2"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span class="hi_text"
                    >Hi,
                    {{
                      userLogin.userData ? userLogin.userData.firstname : ""
                    }}</span
                  >
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                  <li>
                    <router-link
                      :to="{
                        name: 'Dashboard',
                      }"
                      >Dashboard</router-link
                    >
                  </li>
                  <!-- <li><a class="" href="">Settings</a></li> -->
                  <li>
                    <a @click="logOut" class="" href="javascript:void(0)"
                      >Log Out
                    </a>
                  </li>
                </ul>
              </li>
            </ul>           
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row align-items-center justify-content-between">
        <div class="col-lg-2 col-4 col-md-3 d-flex align-items-center">
          <router-link
            :to="'/' + userLogin.getUserUrlName"
            class="navbar-brand"
            v-if="userLogin.getUserUrlName != null"
            ><img src="/assets/images/logo.png"
          /></router-link>
          <router-link v-else to="/" class="navbar-brand"
            ><img src="/assets/images/logo.png"
          /></router-link>
          <!--<img
          src="/assets/images/checkout/free-shipping.png?ver=1.0.2"
          alt="Free Shipping"
          class="ms-2 d-block d-md-none"
        />-->
        </div>
        <div class="col usp-nav">
          <nav>
            <ul>
              <li v-if="userLogin.getUserUrlName != null">
                <router-link
                  :to="'/' + userLogin.getUserUrlName + '/' + 'product'"
                  >{{ props.translationText.text.products }}</router-link
                >
              </li>
              <li v-else>
                <router-link to="/product">{{
                  props.translationText.text.products
                }}</router-link>
              </li>            
              <template v-if="userLogin.getUserUrlName != null">
                <template v-for="(headerData, index) in headerNavigation">
                  <li>
                    <router-link
                      :to="{
                        name: 'CmsPageUser',
                        params: {
                          sluguser: userLogin.getUserUrlName,
                          slug: headerData.slug,
                        },
                      }"
                      >{{ headerData.name }}</router-link
                    >
                  </li>
                </template>
              </template>
              <template v-else>
                <template v-for="(headerData, index) in headerNavigation">
                  <li>
                    <router-link
                      :to="{
                        name: 'CmsPage',
                        params: { slug: headerData.slug },
                      }"
                      >{{ headerData.name }}</router-link
                    >
                  </li>
                </template>
              </template>
              <!--<li>
                <a :href="'/webinar'" target="_blank" rel="noopener noreferrer">
                {{ props.translationText.text.webinar }}
              </a>
              </li>-->
              <template v-if="userLogin.checkIsLoggedIn === true">
                <li>
                <router-link
                  :to="{
                    name: 'Dashboard',
                  }"
                  >Dashboard</router-link
                >
              </li>
              </template>
              <template v-else>
                <li>
                <router-link
                  :to="{
                    name: 'Signin',
                  }"
                  >My Account</router-link
                >
              </li>
              </template>
              
            </ul>
          </nav>
          <div class="menu-icon-area hidden-lg hidden-md">
            <a href="javascript: ;" class="hummenu" id="hummenu"
              ><i class="ri-menu-2-fill"></i
            ></a>
          </div>
        </div>   
       <!--<div class="col-5 col-md-4 col-lg-2 d-none d-md-flex align-items-center justify-content-center">
            <img src="/assets/images/checkout/free-shipping.png?ver=1.0.2" alt="">
        </div> -->  
        <div class="col-xl-2 col-md-4 right-cart-language">
          <span class="cart-icon">
            <a href="javascript:void(0)" @click="opeCartPage"
              ><i class="ri-shopping-cart-2-line"></i
              ><b>{{ cartData.getCartCountQuantity }}</b></a
            >
          </span>
          <div class="dropdown flag">
            <button
              class="dropdown-toggle"
              v-if="userLanguages.getLanguageCode != null"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{
                userLanguages.getLanguageCode.charAt(0).toUpperCase() +
                userLanguages.getLanguageCode.slice(1).toLowerCase()
              }}
            </button>
            <button
              class="dropdown-toggle"
              v-else
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ defaultLanguage }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <template v-for="(language, index) in siteLanguage">
                <li>
                  <a
                    @click="userSiteLanguage(language)"
                    class="dropdown-item"
                    href="#"
                    >{{ language.name }}</a
                  >
                </li>
              </template>
            </ul>
          </div>
          <router-link
            class="btn btn-dark login"
            v-if="userLogin.checkIsLoggedIn === false"
            :to="{
              name: 'Signin',
              params: { sluguser: userLogin.getUserUrlName },
            }"
            >{{ props.translationText.text.login }}</router-link
          >
          <!-- <a href="javascript: ;" class="btn btn-dark login"> Login </a> -->
        </div>
      </div>
    </div>
  </header>
  <div class="slidemenu-overlay"></div>

  <div class="slidemenu" id="slidemenu">
    <div class="slidemenu-header">
      <a href="javascript: ;" class="close-menu" id="closemenu"
        ><i class="ri-close-circle-line"></i
      ></a>
    </div>

    <div class="slidemenu-menu-area">
      <ul class="list-unstyled slidemenu-items">
        <li v-if="userLogin.getUserUrlName != null">
          <router-link :to="'/' + userLogin.getUserUrlName + '/' + 'product'">{{
            props.translationText.text.products
          }}</router-link>
        </li>
        <li v-else>
          <router-link to="/product">{{
            props.translationText.text.products
          }}</router-link>
        </li>
        <template v-if="userLogin.getUserUrlName != null">
          <template v-for="(headerData, index) in headerNavigation">
            <li>
              <router-link
                :to="{
                  name: 'CmsPageUser',
                  params: {
                    sluguser: userLogin.getUserUrlName,
                    slug: headerData.slug,
                  },
                }"
                >{{ headerData.name }}</router-link
              >
            </li>
          </template>
        </template>
        <template v-else>
          <template v-for="(headerData, index) in headerNavigation">
            <li>
              <router-link
                :to="{
                  name: 'CmsPage',
                  params: { slug: headerData.slug },
                }"
                >{{ headerData.name }}</router-link
              >
            </li>
          </template>
        </template>
      </ul>

      <div class="login-signup">
        <router-link
          :to="{
            name: 'JoinTeam',
            params: { sluguser: userLogin.getUserUrlName },
          }"
          class="btn btn-outline-primary"
          >{{ props.translationText.text.joinTeam }}</router-link
        >
        <router-link
          v-if="userLogin.getReferalId != null"
          :to="{
            name: 'Signin',
            params: { sluguser: userLogin.getUserUrlName },
          }"
          class="btn btn-outline-primary"
          >{{ props.translationText.text.login }}</router-link
        >
        <router-link
          v-else
          :to="{ name: 'Signin' }"
          class="btn btn-outline-primary"
          >{{ props.translationText.text.login }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watchEffect, defineProps, onUpdated, onMounted } from "vue";
import { useLoginStore } from "../stores/login";
import { useCartStore } from "../stores/cart";
import { userLanguage } from "../stores/language";
import { useRouter, onBeforeRouteLeave, onBeforeRouteUpdate, useRoute } from "vue-router";
import $ from "jquery";

const router = useRouter();
const userLogin = useLoginStore();
const cartData = useCartStore();
const userLanguages = userLanguage();
const token = ref("");
const props = defineProps(["baseURL", "translationText"]);
const siteLanguage = ref([]);
const defaultLanguage = ref("");
const headerNavigation = ref([]);
const opeCartPage = () => {
  // Prevent cart popup from opening if double=true parameter is set
  if (route.query.double === 'true') {
    console.log('Cart popup disabled during BOGO checkout');
    return;
  }
  window.$("#cartModal").modal("show");
};

const route = useRoute()
const hideCLMText = ref(true)

// Always read query via a computed and normalize to a single string
const productParam = computed(() => {
  const p = route.query?.product
  return Array.isArray(p) ? p[0] : p // normalize
})

watchEffect(() => {
  const v = productParam.value
  // coerce and compare
  if (v === '16' || Number(v) === 16) {
    hideCLMText.value = false
  } else {
    hideCLMText.value = true
  }
})


const userSiteLanguage = (language) => {
  if (userLanguages.getLanguageCode == language.code) {
    console.log("click language", language);
  } else {
    userLanguages.setLanguage(language);
    defaultLanguage.value = language.code;
    getHeader();

    // location.reload();
  }
};
const getLanguage = async () => {
  await axios
    .get(`${props.baseURL}languages`)
    //.get(apiUrl)
    .then((res) => {
      console.log("response ", res.data);
      siteLanguage.value = res.data.languages;

      if (userLanguages.getLanguageCode == null) {
        if (res.data.languages.length > 0) {
          res.data.languages.forEach((language) => {
            if (language.is_default == 1) {
              userLanguages.setLanguage(language);
              console.log("language", language);
              defaultLanguage.value = language.code;
            }
          });
        }
      }
    })
    .catch((err) => {
      //   swal({
      //     text: "Unable to Log you in!",
      //     icon: "error",
      //     closeOnClickOutside: false,
      //   });
      console.log(err);
    })
    .finally(() => {
      //loading = false;
    });
};

const getHeader = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl = props.baseURL + "navigations/header" + languageUrl;
  await axios
    .get(apiUrl)
    //.get(apiUrl)
    .then((res) => {
      console.log("response ", res.data);
      headerNavigation.value = res.data.navigations;
    })
    .catch((err) => {
      //   swal({
      //     text: "Unable to Log you in!",
      //     icon: "error",
      //     closeOnClickOutside: false,
      //   });
      console.log(err);
    })
    .finally(() => {
      //loading = false;
    });
};


onMounted(() => {
  getLanguage();
  getHeader();

  $("#slidemenu").on("show.bs.collapse", ".collapse", function () {
    $("#slidemenu").find(".sub-menu.show").collapse("hide");
  });

  // $("body .slidemenu-items li").on('click', function(){
  //   console.log("anchor clicked ");
  //   $("#slidemenu").removeClass("menu-open");
  //   $(".slidemenu-overlay").removeClass("open");
  // });

  $("#hummenu").click(function () {
    $("#slidemenu").addClass("menu-open");
    $(".slidemenu-overlay").addClass("open");
  });

  $("#closemenu").click(function () {
    $("#slidemenu").removeClass("menu-open");
    $(".slidemenu-overlay").removeClass("open");
  });
  $(".slidemenu-overlay").click(function () {
    $("#slidemenu").removeClass("menu-open");
    $(this).removeClass("open");
  });  
});
const logOut = () => {
  //console.log("Logout");
  userLogin.resetUserLoggedIn();
  router.push({ name: "Home" });
};

onUpdated(() => {
  console.log("Navigation menu");
  $("#slidemenu").removeClass("menu-open");
  $(this).removeClass("open");
});
</script>

<style scoped>
#logo {
  width: 150px;
  margin-left: 20px;
  margin-right: 20px;
}

.nav-link {
  color: rgba(255, 255, 255);
}

#search-button-navbar {
  background-color: #febd69;
  border-color: #febd69;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
#nav-cart-count {
  background-color: red;
  color: white;
  border-radius: 50%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  font-size: 15px;
  margin-left: 10px;
}
#cart {
  position: relative;
}
.Stripe-header {
  background: #000;
  padding: 5px 0;
  border-bottom: 1px solid #333;
  display: block;
}
.Stripe-header p{
  font-size: 13px;
  color: #fff;
  text-align: center;
  margin: 0px;
  font-weight: 500;
}
.Stripe-header p span{
  border-radius: 4px;
  color: #000;
  padding: 2px 5px;
  margin-left: 5px;
  background: #d0f5ef;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1.5px;
}
</style>
